import { PropsWithChildren } from 'react';
import { IThemeContextUpdate, ThemeProvider } from './ThemeProvider.tsx';

export function UIProvider({
  children,
  themeResolver,
}: { themeResolver?: () => Promise<IThemeContextUpdate> } & PropsWithChildren) {
  return <ThemeProvider themeResolver={themeResolver}>{children}</ThemeProvider>;
}
